import * as React from "react";
const SvgEllipse = (props) => /* @__PURE__ */ React.createElement("svg", { width: 8, height: 9, viewBox: "0 0 8 9", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { id: "Ellipse 66", cx: 4, cy: 4.5, r: 4, fill: "#42F18A" }));
export default SvgEllipse;
